/**
 * Shell copy for `src/app` (keys: `shell.app.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  appError: {
    ourTeamHasBeenNotifiedAutomatically: 'Our team has been notified automatically. You can try again or go back home.',
    tryAgain: 'Try again',
    home: 'Home',
    routeStatusStatustext: 'Route {{status}}: {{statusText}}',
    pageNotFound: 'Page not found',
    thisPageDoesNotExistOr: 'This page does not exist or has been moved.',
    anErrorOccurred: 'An error occurred',
  },
  commandPalette: {
    newContact: 'New contact',
    createLeadProspect: 'create lead prospect',
    newCompany: 'New company',
    createCompanyAccount: 'create company account',
    newContent: 'New content',
    content: 'Content',
    createPostPublicationWrite: 'create post publication write',
    generateAContentCalendar: 'Generate a content calendar',
    calendarGenerateSchedulePostsCadenceThem: 'calendar generate schedule posts cadence themes templates ai engine content agentic draft',
    newProject: 'New project',
    projects: 'Projects',
    create: 'create',
    newCampaign: 'New campaign',
    outreach: 'Outreach',
    createEmailingSequence: 'create emailing sequence',
    newDesign: 'New design',
    design: 'Design',
    createVisualGraphicImage: 'create visual graphic image',
    runAnAiTask: 'Run an AI task',
    ai: 'AI',
    agentPersonaLaunchRunTaskCmo: 'agent persona launch run task cmo community manager sdr designer',
    orchestrateAnAiTeamOnA: 'Orchestrate an AI team on a goal',
    orchestrationMultiAgentPlanDagObjective: 'orchestration multi-agent plan dag objective goal team launch',
    enableAnAiCapability: 'Enable an AI capability',
    enableVirtualCmoContentManagerCommunity: 'enable virtual cmo content manager community manager team ai agents capabilities studio',
    toggleTheThemeLightDark: 'Toggle the theme (light / dark)',
    display: 'Display',
    themeDarkLightAppearanceMode: 'theme dark light appearance mode',
    keyboardShortcuts: 'Keyboard shortcuts',
    help: 'Help',
    helpShortcutsKeysKeyboard: 'help shortcuts keys keyboard',
    dashboard: 'Dashboard',
    homeDashboard: 'home dashboard',
    aiGhostwriter: 'AI · Ghostwriter',
    ghostwriterWritingPostLongFormHook: 'ghostwriter writing post long-form hook reach framework rewrite ai',
    analyticsMonitoring: 'Analytics · Monitoring',
    monitoringAlertsAnomaliesDigestsRruleSur: 'monitoring alerts anomalies digests rrule surveillance metrics',
    crmSignals: 'CRM · Signals',
    signalsIntentBuyingIntentLeadScore: 'signals intent buying intent lead score feed rules',
    postsPublications: 'posts publications',
    calendar: 'Calendar',
    planningAgenda: 'planning agenda',
    generateACalendar: 'Generate a calendar',
    calendarGenerateScheduleCadenceThemesTem: 'calendar generate schedule cadence themes templates review preview dry-run content engine',
    linkedinTemplatesLeaderboard: 'LinkedIn templates · Leaderboard',
    templatesLeaderboardRankingPerformanceLi: 'templates leaderboard ranking performance linkedin viral swipe',
    aiReviewWorkshop: 'AI review workshop',
    reviewExpertPanelAgenticLoopGenerate: 'review expert panel agentic loop generate revise critique score content',
    contentEngineAutomations: 'Content engine · Automations',
    automationsContentEnginePolicyLaw25: 'automations content engine policy law 25 learning memory disabled off erase data',
    publishing: 'Publishing',
    publishQueues: 'publish queues',
    publishingHistory: 'Publishing history',
    platforms: 'Platforms',
    networksAccountsConnections: 'networks accounts connections',
    ads: 'Ads',
    adsAdvertisingSponsoringPaidCampaignsBoo: 'ads advertising sponsoring paid campaigns boost',
    adsCommandCenter: 'Ads · Command center',
    adsCommandCenterEngagementPreviewBilling: 'ads command center engagement preview billing calendar planner advertising detail',
    mediaLibrary: 'Media library',
    imagesVideosAssetsFiles: 'images videos assets files',
    documentsInvoices: 'Documents & invoices',
    documentsInvoicesReceivedIssuedQuotesOff: 'documents invoices received issued quotes offers service requests contracts supplier category classification archive zip upload month status',
    linkInBio: 'Link-in-bio',
    bioLinkPageProfileLinktree: 'bio link page profile linktree',
    analytics: 'Analytics',
    statisticsStatsMetrics: 'statistics stats metrics',
    analyticsOverview: 'Analytics · Overview',
    overviewSummaryInsights: 'overview summary insights',
    analyticsHashtags: 'Analytics · Hashtags',
    keywordsTrends: 'keywords trends',
    analyticsCompetitors: 'Analytics · Competitors',
    monitoringBenchmark: 'monitoring benchmark',
    analyticsInfluencers: 'Analytics · Influencers',
    creatorsAmbassadorsInsights: 'creators ambassadors insights',
    analyticsFunnels: 'Analytics · Funnels',
    funnelsConversionStepsFunnel: 'funnels conversion steps funnel',
    analyticsRetention: 'Analytics · Retention',
    cohortsRetentionLoyalty: 'cohorts retention loyalty',
    analyticsAttributionRoi: 'Analytics · Attribution / ROI',
    analyticsGoals: 'Analytics · Goals',
    objectivesGoalsOkrKpiTargets: 'objectives goals okr kpi targets',
    analyticsReports: 'Analytics · Reports',
    exportsInsights: 'exports insights',
    graphicEditorVisuals: 'graphic editor visuals',
    designBrandKits: 'Design · Brand kits',
    brandKitGuidelines: 'brand kit guidelines',
    workflows: 'Workflows',
    automationFlowsOrchestrationScenarios: 'automation flows orchestration scenarios',
    crmLeads: 'CRM & Leads',
    prospectingContacts: 'prospecting contacts',
    crmContacts: 'CRM · Contacts',
    leadsProspects: 'leads prospects',
    crmCompanies: 'CRM · Companies',
    companiesAccounts: 'companies accounts',
    crmGroups: 'CRM · Groups',
    segmentsLists: 'segments lists',
    crmPipeline: 'CRM · Pipeline',
    salesDealsOpportunitiesKanban: 'sales deals opportunities kanban',
    crmDashboards: 'CRM · Dashboards',
    dashboardsIndicatorsKpi: 'dashboards indicators kpi',
    crmFollowUps: 'CRM · Follow-ups',
    followUpsFollowUpsTrackingTasks: 'follow ups follow-ups tracking tasks',
    crmReminders: 'CRM · Reminders',
    remindersAlertsDeadlines: 'reminders alerts deadlines',
    crmDuplicates: 'CRM · Duplicates',
    duplicatesMergeCleanup: 'duplicates merge cleanup',
    crmAppointments: 'CRM · Appointments',
    schedulerAppointmentsBookingCalendarAgen: 'scheduler appointments booking calendar agenda',
    crmForms: 'CRM · Forms',
    formsWebFormsCaptureLeads: 'forms web forms capture leads',
    crmDocuments: 'CRM · Documents',
    documentsFilesContractsSignatures: 'documents files contracts signatures',
    crmSettings: 'CRM · Settings',
    configurationSettings: 'configuration settings',
    aiRecommendations: 'AI recommendations',
    recommendationsAdvisorAiAnalysisSuggesti: 'recommendations advisor ai analysis suggestions tips optimize best time boost',
    marketingStrategy: 'Marketing strategy',
    marketingCommunicationStrategyGtmGoTo: 'marketing communication strategy gtm go-to-market positioning pillars channels audiences smart objectives plan timeline launch autonomy law 25 measure recommend improve epic 7',
    prospectingDiscovery: 'Prospecting · Discovery',
    discoveryGeoProspectingGooglePlacesOpenc: 'discovery geo prospecting google places opencorporates crunchbase apollo',
    prospectingOffersIcp: 'Prospecting · Offers & ICP',
    offersOfferingsIcpProspectProductBrand: 'offers offerings icp prospect product brand ideal customer kingdom kimmobilia',
    prospectingRecommendations: 'Prospecting · Recommendations',
    recommendationRankingFitScoreProspectsOb: 'recommendation ranking fit score prospects objective goal product leaderboard',
    prospectingCalendar: 'Prospecting · Calendar',
    calendarCadenceMultiTouchSequenceProspec: 'calendar cadence multi-touch sequence prospecting planning touches',
    prospectingAccountIntelligence: 'Prospecting · Account intelligence',
    accountIntelligenceDossierAiAnalysisProf: 'account intelligence dossier ai analysis profile competitor market strategy',
    contentCarouselEditor: 'Content · Carousel editor',
    carouselSlidesExportPngPdfDesign: 'carousel slides export png pdf design content',
    contentRichContentStudio: 'Content · Rich content studio',
    infographicAnimatedGifMp4VideoPost: 'infographic animated gif mp4 video post-pack caption hashtags ai generation multimedia multi-platform linkedin',
    contentVideoAudioStudio: 'Content · Video & audio studio',
    videoAudioStudioTranscriptionVoiceTts: 'video audio studio transcription voice tts voiceover avatar reel clip subtitles cloned',
    crmActivityFeed: 'CRM · Activity feed',
    activityFeedCollaborationSharesAssignmen: 'activity feed collaboration shares assignments log team',
    b2bDatabase: 'B2B database',
    b2bProspectingDirectoryEnrichmentCompany: 'b2b prospecting directory enrichment company database',
    b2bDatabaseSearch: 'B2B database · Search',
    b2bSearchDirectoryFiltersCompaniesContac: 'b2b search directory filters companies contacts',
    b2bDatabaseMyLists: 'B2B database · My lists',
    listsBuildAListSegmentsProspecting: 'lists build a list segments prospecting',
    marketplace: 'Marketplace',
    marketplaceProvidersServicesBookings: 'marketplace providers services bookings',
    marketplaceExplore: 'Marketplace · Explore',
    exploreProvidersDirectoryServices: 'explore providers directory services',
    marketplaceProviderWorkspace: 'Marketplace · Provider workspace',
    providerSupplierDashboardServices: 'provider supplier dashboard services',
    marketplaceMyBookings: 'Marketplace · My bookings',
    bookingsOrders: 'bookings orders',
    marketplaceMyReviews: 'Marketplace · My reviews',
    ratingsReviewsScores: 'ratings reviews scores',
    socialLeads: 'Social leads',
    socialLeadsSocialNetworksProspects: 'social leads social networks prospects',
    socialListening: 'Social listening',
    listeningMonitoringMentionsSocialMonitor: 'listening monitoring mentions social monitoring',
    emailOutreach: 'Email Outreach',
    emailingCampaigns: 'emailing campaigns',
    outreachCampaigns: 'Outreach · Campaigns',
    outreachSequences: 'Outreach · Sequences',
    outreachUnibox: 'Outreach · Unibox',
    uniboxUnifiedInboxRepliesConversations: 'unibox unified inbox replies conversations',
    outreachDeliverability: 'Outreach · Deliverability',
    sendingDeliverabilityWarmupSendersDomain: 'sending deliverability warmup senders domains',
    outreachTemplates: 'Outreach · Templates',
    outreachSettings: 'Outreach · Settings',
    configurationSender: 'configuration sender',
    socialInbox: 'Social inbox',
    messagesConversations: 'messages conversations',
    emailConnectedMailboxes: 'Email · Connected mailboxes',
    emailMailboxGmailOutlookYahooImap: 'email mailbox gmail outlook yahoo imap oauth app password connect sync',
    emailInbox: 'Email · Inbox',
    emailInboxClassificationPriorityCategory: 'email inbox classification priority category reply ai draft triage',
    emailRulesAutomation: 'Email · Rules & automation',
    emailRulesAutomationTriagePolicyAutonomy: 'email rules automation triage policy autonomy law 25 folders categories decisions kill switch stop',
    emailVisualBuilder: 'Email · Visual builder',
    emailVisualBuilderAutomationFlowDrag: 'email visual builder automation flow drag drop nodes trigger classify reply approval',
    emailTemplates: 'Email · Templates',
    emailTemplatesReplySubjectBodyVariables: 'email templates reply subject body variables preview',
    community: 'Community',
    communityProductivityRepliesMacrosSlaCsa: 'community productivity replies macros sla csat campaigns influencers inbox',
    communityRepliesMacros: 'Community · Replies & macros',
    cannedSavedRepliesMacros: 'canned saved replies macros',
    communitySla: 'Community · SLA',
    slaDeadlinesPoliciesBreachesBreach: 'sla deadlines policies breaches breach',
    communitySatisfactionCsat: 'Community · Satisfaction (CSAT)',
    csatSatisfactionScoreSurvey: 'csat satisfaction score survey',
    communityInfluencerCampaigns: 'Community · Influencer campaigns',
    influencerCampaignsInfluencerBriefDelive: 'influencer campaigns influencer brief deliverables',
    ambassadorsFeedToShare: 'Ambassadors · Feed to share',
    advocacyEmployeeAdvocacyAmbassadorsEmplo: 'advocacy employee advocacy ambassadors employees share amplify link tracking utm consent',
    ambassadorsLeaderboard: 'Ambassadors · Leaderboard',
    ambassadorsCampaignsAdmin: 'Ambassadors · Campaigns (admin)',
    advocacyCampaignsAdminAmbassadorsInviteM: 'advocacy campaigns admin ambassadors invite measure amplify',
    communitiesMyEngagements: 'Communities · My engagements',
    communitiesAmplificationEngagementCommen: 'communities amplification engagement comment reaction approve publish member account advocacy pod authentic',
    communitiesGroupsAdmin: 'Communities · Groups (admin)',
    communitiesGroupMembersInviteEditorPubli: 'communities group members invite editor publisher amplifier account connection internal external',
    communitiesPolicyCompliance: 'Communities · Policy & compliance',
    communitiesPolicyComplianceAutomaticOptI: 'communities policy compliance automatic opt-in law 25 casl kill switch emergency stop threshold cap quiet hours',
    communitiesMeasurement: 'Communities · Measurement',
    communitiesMeasurementParticipationComme: 'communities measurement participation comments reactions leaderboard members platform',
    inboxApprovals: 'Inbox · Approvals',
    inboxAutomation: 'Inbox · Automation',
    aiTeam: 'AI team',
    agentsPersonasVirtualCmoCommunityManager: 'agents personas virtual cmo community manager designer sdr team enable launch task capabilities ai hub',
    aiOrchestration: 'AI orchestration',
    orchestrationTeamMultiAgentPlanDag: 'orchestration team multi-agent plan dag objective goal graph collective decision autonomy l1 l2 l3 l4',
    aiTeamBuilder: 'AI team builder',
    composeTeamAgentsSeatsRolesAccountant: 'compose team agents seats roles accountant tax specialist assistant number skills tools autonomy l0 l5 multi-instance',
    aiTeamTemplates: 'AI team templates',
    templatesTeamRolesReusableInstantiatePla: 'templates team roles reusable instantiate platform admin',
    aiTaskQueue: 'AI task queue',
    queueTasksPoolAssignClaimAgent: 'queue tasks pool assign claim agent team unassigned',
    flowStudioWorkflows: 'Flow studio (workflows)',
    studioWorkflowProcessBpmnDmnDecision: 'studio workflow process bpmn dmn decision drag drop nodes diagram visualization execution',
    aiAssistant: 'AI assistant',
    copilotAi: 'copilot ai',
    aiContentStudio: 'AI · Content studio',
    carouselThreadPostGenerationStudioAi: 'carousel thread post generation studio ai',
    aiRepurposing: 'AI · Repurposing',
    recycleUrlArticlePostsRepurposeAi: 'recycle url article posts repurpose ai',
    contentIdeaFeed: 'Content · Idea feed',
    ideasFeedCaptureUrlInspirationMonitoring: 'ideas feed capture url inspiration monitoring editorial ranking',
    prospectingIdentifiedVisitors: 'Prospecting · Identified visitors',
    visitorsReverseIpCompaniesWebsiteIntent: 'visitors reverse ip companies website intent consent visits',
    prospectingJobChangeAlerts: 'Prospecting · Job change alerts',
    jobChangePositionChangeEmploymentAlerts: 'job change position change employment alerts signals contacts promotion',
    prospectingInboundLeadRouting: 'Prospecting · Inbound lead routing',
    inboundLeadRoutingRulesAssignmentQueue: 'inbound lead routing rules assignment queue team owner',
    aiLongFormStudio: 'AI · Long-form studio',
    aiCanvas: 'AI · Canvas',
    canvasLongDocumentSectionsSidebarSelecti: 'canvas long document sections sidebar selection seo ai editor',
    aiGridBulkGeneration: 'AI · Grid (bulk generation)',
    gridTableBatchBulkGenerationRows: 'grid table batch bulk generation rows content ai',
    analyticsGeoAiVisibility: 'Analytics · GEO (AI visibility)',
    geoGenerativeEngineOptimizationVisibilit: 'geo generative engine optimization visibility ai engines chatgpt perplexity citations diagnosis',
    aiHookLibrary: 'AI · Hook library',
    hooksTemplatesSwipeFewShotHooks: 'hooks templates swipe few-shot hooks ai library content',
    aiBrandVoice: 'AI · Brand voice',
    toneStyleProfileScoreBrandVoice: 'tone style profile score brand voice ai',
    aiABCopyTests: 'AI · A/B copy tests',
    variantsAbTestWinnerCopyAi: 'variants ab test winner copy ai',
    aiSuggestions: 'AI · Suggestions',
    recommendationsAnalyticsIdeasSuggestions: 'recommendations analytics ideas suggestions ai',
    aiPersonalization: 'AI · Personalization',
    tokensCrmMergePersonalizationAi: 'tokens crm merge personalization ai',
    aiCommunityManager: 'AI · Community Manager',
    repliesModerationCommentsDmDraftCommunit: 'replies moderation comments dm draft community ai',
    aiRagDocuments: 'AI · RAG documents',
    ragDocumentsSearchIndexPdfAi: 'rag documents search index pdf ai',
    aiMemory: 'AI · Memory',
    memoryPreferencesProfileContextAi: 'memory preferences profile context ai',
    aiApprovals: 'AI approvals',
    validationApprovalsAgentsActionsAi: 'validation approvals agents actions ai',
    aiActivity: 'AI activity',
    agentsRunsExecutions: 'agents runs executions',
    parameters: 'Parameters',
    settingsConfigurationOptions: 'settings configuration options',
    settingsProfile: 'Settings · Profile',
    themeAccount: 'theme account',
    settingsCredits: 'Settings · Credits',
    settingsAiRegistry: 'Settings · AI registry',
    settingsConnections: 'Settings · Connections',
    integrationsAccountsNetworks: 'integrations accounts networks',
    settingsReviewPolicy: 'Settings · Review policy',
    reviewApprovalAutoPublishingPolicyRules: 'review approval auto-publishing policy rules simulate law 25 validation publish',
    monitoringListening: 'Monitoring / Listening',
    monitoringListeningSocialListeningMentio: 'monitoring listening social listening mentions monitors brand keyword competitor sentiment topics alerts signals',
    reportsBenchmark: 'Reports & Benchmark',
    influencerCampaigns: 'Influencer campaigns',
    influencersInfluencerCampaignsShortlistP: 'influencers influencer campaigns shortlist pipeline stages measurement attribution funnel deliverables',
    openCloseThePalette: 'Open / close the palette',
    searchOpenThePalette: 'Search (open the palette)',
    keyboardShortcutsHelp: 'Keyboard shortcuts help',
    goToASectionGD: 'Go to a section (g d, g c, …)',
    navigateTheResults: 'Navigate the results',
    openTheSelection: 'Open the selection',
    closeOrGoBack: 'Close (or go back)',
    commandPalette: 'Command palette',
    searchForAPageOrAn: 'Search for a page or an action…',
    search: 'Search',
    back: 'Back',
    results: 'Results',
    noResults: 'No results.',
    removeLabelFromFavorites: 'Remove {{label}} from favorites',
    addLabelToFavorites: 'Add {{label}} to favorites',
    recent: 'Recent',
    groupFavorites: 'Favorites',
    groupRecent: 'Recent',
    groupActions: 'Actions',
    groupNavigation: 'Navigation',
    analyticsSdkInstallation: 'Analytics · SDK installation',
    sdkPixelSnippetInstallationIngestionKey: 'sdk pixel snippet installation ingestion key tracking consent cursor lovable',
    analyticsExperiments: 'Analytics · Experiments',
    abTestABExperimentVariants: 'ab test a/b experiment variants price pricing audit',
  },
  keyboardShortcuts: {
    dashboard: 'Dashboard',
    content: 'Content',
    calendar: 'Calendar',
    publishing: 'Publishing',
    platforms: 'Platforms',
    mediaLibrary: 'Media library',
    analytics: 'Analytics',
    workflows: 'Workflows',
    crmLeads: 'CRM & Leads',
    socialLeads: 'Social leads',
    emailOutreach: 'Email Outreach',
    socialInbox: 'Social inbox',
    socialListening: 'Social listening',
    projects: 'Projects',
    aiActivity: 'AI activity',
    parameters: 'Parameters',
    keyboardShortcuts: 'Keyboard shortcuts',
    general: 'General',
    commandPalette: 'Command palette',
    search: 'Search',
    showThisHelp: 'Show this help',
    closeGoBack: 'Close / go back',
    navigationGThen: 'Navigation “g” then…',
    navigationContinued: 'Navigation (continued)',
    inThePalette: 'In the palette',
    browseTheResults: 'Browse the results',
    openTheSelection: 'Open the selection',
    tipPress: 'Tip: press',
    thenALetterToSwitchSection: 'then a letter to switch section without leaving the keyboard.',
  },
  layoutsAccountSwitcher: {
    myAccount: 'My account',
    activeAccountActivelabel: 'Active account: {{activeLabel}}',
    managedAccounts: 'Managed accounts',
    permission: 'permission',
    granted: 'granted',
  },
  layoutsActingTenantBanner: {
    youAreActingInTheAccount: 'You are acting in the account of',
    accessLimitedToTheGrantedPermissions: '. Access limited to the granted permissions.',
    backToMyAccount: 'Back to my account',
  },
  layoutsDashboardLayout: {
    notIncludedInYourPlan: 'Not included in your plan',
    removeLabelFromFavorites: 'Remove {{label}} from favorites',
    addLabelToFavorites: 'Add {{label}} to favorites',
    removeFromFavorites: 'Remove from favorites',
    addToFavorites: 'Add to favorites',
    expandAll: 'Expand all',
    collapseAll: 'Collapse all',
    expandAll2: '⊞ Expand all',
    collapseAll2: '⊟ Collapse all',
    recent: 'Recent',
    erase: 'Erase',
    skipToMainContent: 'Skip to main content',
    buildProvenanceVersionCommitDate: 'Build provenance (version, commit, date)',
  },
  layoutsNavCatalog: {
    aiRecommendations: 'AI recommendations',
    marketingStrategy: 'Marketing strategy',
    contentApprovals: 'Content approvals',
    generateACalendar: 'Generate a calendar',
    linkedinTemplates: 'LinkedIn templates',
    aiReviewWorkshop: 'AI review workshop',
    adsCommandCenter: 'Ads · Command center',
    reportsBenchmark: 'Reports & Benchmark',
    geoAiVisibility: 'GEO · AI visibility',
    ideaFeed: 'Idea feed',
    studioDiagrams: 'Studio · Diagrams',
    studioAllInOne: 'Studio · All-in-one',
    studioSourcesNotebooklm: 'Studio · Sources (NotebookLM)',
    studioAiMediaEditing: 'Studio · AI media (editing)',
    studioFlowsBpmn: 'Studio · Flows (BPMN)',
    identifiedVisitors: 'Identified visitors',
    jobChangeAlerts: 'Job-change alerts',
    inboundLeadRouting: 'Inbound lead routing',
    monitoringListening: 'Monitoring / Listening',
    influencerCampaigns: 'Influencer campaigns',
    ambassadorsAdvocacy: 'Ambassadors (advocacy)',
    contentCommunities: 'Content communities',
    n247Team: '24/7 team',
    n247CommandCenter: '24/7 command center',
    teamBuilder: 'Team builder',
    teamTemplates: 'Team templates',
    taskQueue: 'Task queue',
    orchestrationAssistant: 'Orchestration & Assistant',
    aiTools: 'AI tools',
    studioLongFormArticles: 'Studio · Long-form (articles)',
    canvas: 'Canvas',
    gridBulkGeneration: 'Grid · bulk generation',
    documentsInvoices: 'Documents & invoices',
    newContent: 'New content',
    studioVideoAudio: 'Studio · Video & audio',
    brandKits: 'Brand kits',
    publishingHistory: 'Publishing history',
    publishingAssistant: 'Publishing assistant',
    expressAdCreationAi: 'Express ad creation (AI)',
    prospectingStrategy: 'Prospecting strategy',
    monitoringAlerts: 'Monitoring & alerts',
    attributionRoi: 'Attribution / ROI',
    automations: 'Automations',
    aiLearning: 'AI learning',
    inboxAutomation: 'Inbox · Automation',
    repliesMacros: 'Replies & macros',
    slaSatisfaction: 'SLA & satisfaction',
    salesPipeline: 'Sales pipeline',
    intentSignals: 'Intent signals',
    uniboxReplies: 'Unibox (replies)',
    profile: 'Profile',
    teamInvitations: 'Team & invitations',
    organization: 'Organization',
    notifications: 'Notifications',
    workspaces: 'Workspaces',
    rolesPermissions: 'Roles & permissions',
    networkConnections: 'Network connections',
    connectors: 'Connectors',
    integrations: 'Integrations',
    apiDevelopers: 'API & developers',
    sendingMailboxes: 'Sending mailboxes',
    subscription: 'Subscription',
    billing: 'Billing',
    aiCredits: 'AI credits',
    perUserBudgets: 'Per-user budgets',
    referral: 'Referral',
    aiRegistry: 'AI registry',
    aiModelsAdmin: 'AI models (admin)',
    llmKeysByok: 'LLM keys (BYOK)',
    aiGovernance: 'AI governance',
    contentEngine: 'Content engine',
    reviewPolicy: 'Review policy',
    trustCenter: 'Trust center',
    home: 'Home',
    content: 'Content',
    create: 'Create',
    libraryApproval: 'Library & approval',
    engagement: 'Engagement',
    inboxCommunity: 'Inbox & community',
    listeningMonitoring: 'Listening & monitoring',
    email: 'Email',
    connectedMailboxes: 'Connected mailboxes',
    emailInbox: 'Email inbox',
    rulesAutomation: 'Rules & automation',
    visualBuilder: 'Visual builder',
    emailTemplates: 'Email templates',
    growth: 'Growth',
    outreachMarket: 'Outreach & market',
    ads: 'Ads',
    analytics: 'Analytics',
    aiAutomation: 'AI & Automation',
    parameters: 'Parameters',
    accountTeam: 'Account & team',
    connectionsIntegrations: 'Connections & integrations',
    planCredits: 'Plan & credits',
    aiCompliance: 'AI & compliance',
    prospecting: 'Prospecting',
    validationDeck: 'Validation deck',
    conversationsToJoin: 'Conversations to join',
    accountHealth: 'Account health',
    partnerPrograms: 'Partner programs',
    inAppChecklists: 'In-app checklists',
  },
  layoutsSectionTabs: {
    analytics: 'Analytics',
    community: 'Community',
    outreach: 'Outreach',
    parameters: 'Parameters',
    publishing: 'Publishing',
    overview: 'Overview',
    overviewSummaryKpi: 'overview summary kpi',
    aiInsights: 'AI insights',
    predictiveMlLeadScoreDealWin: 'predictive ml lead score deal win',
    keywordsTrends: 'keywords trends',
    followedAccounts: 'Followed accounts',
    watchlistPeopleAccounts: 'watchlist people accounts',
    monitoringBenchmark: 'monitoring benchmark',
    creatorsAmbassadors: 'creators ambassadors',
    funnelsConversion: 'funnels conversion',
    retention: 'Retention',
    cohortsLoyalty: 'cohorts loyalty',
    goalsOkrKpiTargets: 'goals okr kpi targets',
    exportsBuilder: 'exports builder',
    alertsAnomaliesDigests: 'alerts anomalies digests',
    inboxPerformance: 'Inbox performance',
    messagingResponseTime: 'messaging response time',
    teamProductivity: 'Team productivity',
    agentsWorkloadTeam: 'agents workload team',
    demographicsSubscribersFollowers: 'demographics subscribers followers',
    bestTime: 'Best time',
    hourPublishBestTime: 'hour publish best time',
    webTraffic: 'Web traffic',
    siteVisitsUtm: 'site visits utm',
    shareOfVoice: 'Share of voice',
    shareOfVoiceCompetitors: 'share of voice competitors',
    imageRecognitionOcr: 'image recognition ocr',
    brandingVisualConsistency: 'branding visual consistency',
    dashboards: 'Dashboards',
    customDashboards: 'custom dashboards',
    emotionToneComments: 'emotion tone comments',
    trendsEmergingTopics: 'trends emerging topics',
    crmInsights: 'CRM insights',
    salesPipelineAnalysis: 'sales pipeline analysis',
    geoAiVisibility: 'GEO (AI visibility)',
    generativeEngineOptimizationChatgptPerpl: 'generative engine optimization chatgpt perplexity',
    leadsProspects: 'leads prospects',
    companiesAccounts: 'companies accounts',
    segmentsLists: 'segments lists',
    dynamicLists: 'Dynamic lists',
    savedSearchesFilters: 'saved searches filters',
    leadsJourneyStagesLifecycle: 'leads journey stages lifecycle',
    icpProspecting: 'ICP prospecting',
    objectivesCampaignsIcpCriteria: 'objectives campaigns icp criteria',
    salesDealsOpportunitiesKanban: 'sales deals opportunities kanban',
    bookingCalendarReservation: 'booking calendar reservation',
    webCaptureLeads: 'web capture leads',
    contractsSignaturesFiles: 'contracts signatures files',
    intentBuyingIntent: 'intent buying intent',
    followUpsTracking: 'follow ups tracking',
    deadlinesAlerts: 'deadlines alerts',
    mergeCleanup: 'merge cleanup',
    sharingContactsTeamAccess: 'sharing contacts team access',
    activity: 'Activity',
    logActivityFeed: 'log activity feed',
    indicatorsKpi: 'indicators kpi',
    settings: 'Settings',
    dashboardCommentsModeration: 'dashboard comments moderation',
    themes: 'Themes',
    topicsCategories: 'topics categories',
    targetedEngagement: 'Targeted engagement',
    targetingAccountsToEngage: 'targeting accounts to engage',
    aiAutomation: 'AI automation',
    policyLaw25CommunityManager: 'policy law 25 community manager',
    repliesMacros: 'Replies & macros',
    savedRepliesCanned: 'saved replies canned',
    editorialLine: 'Editorial line',
    guidelinesToneRules: 'guidelines tone rules',
    interactionsReactions: 'interactions reactions',
    deadlinesPoliciesBreaches: 'deadlines policies breaches',
    satisfactionCsat: 'Satisfaction (CSAT)',
    satisfactionSurveyScore: 'satisfaction survey score',
    competitorsShareOfVoice: 'competitors share of voice',
    influencerCampaigns: 'Influencer campaigns',
    influencerBriefDeliverables: 'influencer brief deliverables',
    emailingSequence: 'emailing sequence',
    sequences: 'Sequences',
    multichannelSteps: 'multichannel steps',
    tasks: 'Tasks',
    queueLinkedinSmsWhatsappManualCall: 'queue linkedin sms whatsapp manual call',
    dialerPhoneClickToCallLog: 'dialer phone click-to-call log',
    unifiedInboxRepliesConversations: 'unified inbox replies conversations',
    deliverability: 'Deliverability',
    warmupSendersDomains: 'warmup senders domains',
    emailTemplates: 'email templates',
    configurationSender: 'configuration sender',
    creditsBilling: 'Credits & Billing',
    aiCreditsBilling: 'ai credits billing',
    planOffer: 'plan offer',
    aiRegistry: 'AI registry',
    agentsModels: 'agents models',
    aiModels: 'AI models',
    llmCatalog: 'llm catalog',
    llmKeysByok: 'LLM keys (BYOK)',
    byokProviderApiKeys: 'byok provider api keys',
    sendingMailboxes: 'Sending mailboxes',
    mailboxSmtpSender: 'mailbox smtp sender',
    aiGovernance: 'AI governance',
    reviewPolicy: 'Review policy',
    trustCenter: 'Trust center',
    privacyLaw25Data: 'privacy law 25 data',
    workspaces: 'Workspaces',
    rolesPermissions: 'Roles & permissions',
    delegation: 'Delegation',
    delegationExternalAccessCrossAccount: 'delegation external access cross-account',
    developerApi: 'Developer API',
    apiKeysWebhooks: 'api keys webhooks',
    integrations: 'Integrations',
    connectedAccounts: 'Connected accounts',
    socialNetworksConnections: 'social networks connections',
    team: 'Team',
    invitationsMembers: 'invitations members',
    accountThemeLanguage: 'account theme language',
    publicationTracking: 'Publication tracking',
    trackingJobStatusProgress: 'tracking job status progress',
    competitors: 'Competitors',
    influencers: 'Influencers',
    objectives: 'Objectives',
    reports: 'Reports',
    brand: 'Brand',
    trends: 'Trends',
    companies: 'Companies',
    groups: 'Groups',
    journey: 'Journey',
    appointment: 'Appointment',
    forms: 'Forms',
    signals: 'Signals',
    followUps: 'Follow-ups',
    reminders: 'Reminders',
    duplicates: 'Duplicates',
    shares: 'Shares',
    comments: 'Comments',
    campaigns: 'Campaigns',
    calls: 'Calls',
    subscription: 'Subscription',
    referral: 'Referral',
    organization: 'Organization',
    connectors: 'Connectors',
    profile: 'Profile',
    inAppChecklists: 'In-app checklists',
    onboardingWidgetProductSteps: 'onboarding widget product steps',
    siteAudit: 'Site audit',
    seoCroGeoSiteAuditPrompt: 'seo cro geo site audit prompt cursor',
    asoAppStore: 'ASO (App Store)',
    asoAppStoreGooglePlayListing: 'aso app store google play listing mobile application itunes',
    mediaPr: 'Media / PR',
    pressRelationsJournalistsMediaPr: 'press relations journalists media pr',
    sdkInstallation: 'SDK installation',
    sdkPixelSnippetInstallationIngestionKey: 'sdk pixel snippet installation ingestion key tracking consent',
    experiments: 'Experiments',
    abTestABExperimentVariants: 'ab test a/b experiment variants price pricing landing',
    caseStudies: 'Case studies',
    testimonialResultsConsentCaseStudy: 'testimonial results consent case study',
    chatApps: 'Chat apps',
    slackSmsTextCopilotKarexiaChat: 'slack sms text copilot /karexia chat',
  },
  layoutsWorkspaceSwitcher: {
    couldNotSwitchWorkspace: 'Could not switch workspace.',
    workspaceV: 'Workspace: {{v}}',
    wholeAccount: 'Whole account',
    workspaces: 'Workspaces',
  },
  routeErrorBoundary: {
    anErrorOccurredOnThisPage: 'An error occurred on this page',
    theRestOfTheApplicationIs: 'The rest of the application is still usable. Try again or go back.',
    tryAgain: 'Try again',
    back: 'Back',
  },
  router: {
    loading: 'Loading…',
    loadingTheApplication: 'Loading the application',
  },
  updateBanner: {
    aNewVersionIsAvailable: 'A new version is available.',
    refreshToLoadTheLatestUpdate: 'Refresh to load the latest update.',
    refreshing: 'Refreshing…',
    refresh: 'Refresh',
    dismissThisUpdateNotification: 'Dismiss this update notification',
  },
};

export default en;
